<template>
    <div class="card">
        <div class="card-body">
            <h3>Engineer Notes</h3>
            <p>Notes for the engineer that would be helpful on next visit/moving forward</p>
            <div class="form-group">
                <textarea
                    v-model="newNotes"
                    placeholder="Write engineer notes here..."
                    class="form-control"
                />
                <small>Not visible on customer copy</small>
                <small
                    class="note-warning"
                    v-if="newNotes"
                >Note not saved yet, press Add Note to save</small>
                <div>
                    <button
                        type="button"
                        class="btn btn-secondary"
                        @click="saveNotes"
                    >
                        Add Note
                    </button>
                </div>
            </div>

            <div>
                <div
                    v-for="note in engineerNotes"
                    :key="note.id"
                    class="comment"
                >
                    <span class="comment__user">{{ note.user ? note.user.name : 'Unknown' }}</span>
                    <div
                        class="comment__content"
                        v-text="note.content"
                    />
                    <span class="comment__time">
                        {{ noteTimestamp(note) }}
                    </span>
                </div>
            </div>

            <div>
                <h3>Engineer Attachments</h3>
                <small>Not visible on customer copy</small>
                <attachments
                    v-model="attachments"
                    type="App\Site"
                    :id="siteId"
                />
                <span
                    class="form-error"
                    style="margin-top: 1rem"
                    v-if="attachmentMessage"
                >Note: {{ attachmentMessage }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import SitesService from '../../../services/SitesService';
import Attachments from '../../AttachmentsComponent';
import UsesErrors from "../../../mixins/UsesErrors";
import UsesInfoMessage from "../../../mixins/UsesInfoMessage";
import UsesErrorMessage from "../../../mixins/UsesErrors";

export default {
    components: {
        Attachments,
    },
    mixins: [
        UsesInfoMessage,
        UsesErrorMessage,
    ],
    props: {
        siteId: {
            required: true,
            type: [Number, String],
        }
    },
    data() {
        return {
            newNotes: '',
            engineerNotes: [],
            attachments: [],
            attachmentMessage: null,
        }
    },
    watch: {
        siteId: {
            handler() {
                this.loadNotes();
            },
            immediate: true,
        }
    },
    methods: {
        loadNotes() {
            SitesService.engineerNotes(this.siteId)
                .then(res => {
                    this.engineerNotes = res.data;
                })
                .catch(error => {
                    this.setErrorMessage('Error loading engineer notes');
                    console.error(error);
                })
        },
        saveNotes() {
            if (!this.newNotes) {
                return;
            }

            this.setSaving(true);
            this.clearErrors();
            SitesService.storeEngineerNotes(this.siteId, this.newNotes)
                .then(res => {
                    this.engineerNotes = res.data;
                    this.setInfoMessage('Note saved successfully');
                    this.newNotes = '';
                    this.clearSaving();
                })
                .catch(error => {
                    this.setErrorMessage('Error saving note, try again');
                    this.clearSaving();
                    console.error(error)
                })
        },

        noteTimestamp(note) {
            return window.moment(note.created_at).format('llll');
        }
    }
}
</script>

<style scoped>
.comment__content {
    white-space: pre;
}
.note-warning {
    color: #e2a803;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/parts/EngineerNotesComponent.vue